// extracted by mini-css-extract-plugin
export var fullWidthButton = "_nh-0";